import React, { Component } from 'react';
import { Slot } from 'react-page-layout';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import MainFooter from 'components/main-footer';
import mapFacets from 'util/react/facet';
import MainContent from 'containers/main-content';

export default class TwoColumns extends Component {
    static propTypes = {
        facet: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    };

    render() {
        const { facet, ...props } = this.props;
        const facetClasses = mapFacets(facet, 'layout');
        const content = [
            <Slot key="sidebar" className="layout--sidebar" name="sidebar"/>,
            <MainContent key="main-content" className="layout--page grid grid__two-cols">
                <Slot className="layout--page-content" name="content"/>
                <MainFooter/>
            </MainContent>,

        ];

        return (
            <div {...props} className={classnames('layout', 'layout__two-cols', facetClasses)}>
                <div className="layout--row">
                    { facet && Array.isArray(facet) && facet.includes('sidebar-right') ? content.reverse() : content }
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/layouts/two-columns.js